{
    "TelsysList_Column_TelSysID": "ID",
    "TelsysList_Column_Description": "Beschrijving",
    "TelsysList_Column_Trial": "Proces",
    "TelsysList_Trial_Yes": "Ja",
    "TelsysList_Trial_No": "Nee",
    "TelsysList_Column_PlatformType": "Platformtype",
    "TelsysList_Column_Licence": "Licentie",
    "TelsysList_Column_Partitions": "Partities",
    "TelsysList_Column_Extensions": "Uitbreidingen",
    "TelsysList_Column_AcdAgents": "ACD-agenten",
    "TelsysList_Column_AppUsers": "Applicatiegebruikers",
    "TelsysList_Column_Status": "Status",
    "TelsysList_Filter_PlatformType": "Platformtype",
    "TelsysList_Filter_ReportLicence": "Rapportagevergunning",
    "TelsysList_Filter_ModuleStatus": "Modulestatus",
    "TelsysList_LicenceFilter_HistoricOnly": "Historische alleen",
    "TelsysList_LicenceFilter_Standard": "Standaard \/ BLF",
    "TelsysList_LicenceFilter_Enterprise": "Onderneming",
    "TelsysList_LicenceFilter_Acd": "ACD",
    "TelsysList_LicenceFilter_None": "Geen",
    "TelsysList_LicenceFilter_Mixed": "Gemengd",
    "TelsysList_LicenceFilter_Unknown": "Onbekend",
    "TelsysList_ModuleStatus_mNeg1": "Onbekend",
    "TelsysList_ModuleStatus_m0": "Net begonnen of gesloten",
    "TelsysList_ModuleStatus_m1": "Gestopt",
    "TelsysList_ModuleStatus_m2": "Beginnen",
    "TelsysList_ModuleStatus_m3": "Einde",
    "TelsysList_ModuleStatus_m4": "Gehandicapt",
    "TelsysList_ModuleStatus_m5": "Actief (inactief)",
    "TelsysList_ModuleStatus_m6": "Rijden (zonder licentie)",
    "TelsysList_ModuleStatus_m7": "Starten met kerncommunicatie",
    "TelsysList_ModuleStatus_m8": "Apparaatbewaking starten",
    "TelsysList_ModuleStatus_m9": "Communicatie stopzetten",
    "TelsysList_ModuleStatus_m10": "Rennen",
    "TelsysList_ModuleStatus_m11": "Bezig met uitvoeren (waarschuwingen)",
    "TelsysList_ModuleStatus_m12": "Synchroniseren",
    "TelsysList_ModuleStatus_m13": "Gesynchroniseerd",
    "TelsysList_ModuleStatus_m14": "Gesynchroniseerd (waarschuwingen)",
    "TelsysList_ModuleStatus_m15": "Synchronisatie mislukt",
    "TelsysList_ModuleStatus_m16": "Niet in gebruik",
    "TelsysList_ModuleStatus_m17": "De communicatie eindigde op een onprettige manier.",
    "TelsysList_ModuleStatus_m18": "Synchronisatie mislukt",
    "TelsysList_ModuleStatus_m19": "Bots uitgeschakeld",
    "TelsysList_ModuleStatus_m20": "Bots uitgeschakeld (waarschuwingen)",
    "TelsysList_ModuleStatus_m21": "Inactief (onjuiste toestemming)",
    "TelsysList_CountLink_PartitionsAria": "Open partities worden gefilterd naar deze telefonieserver.",
    "TelsysList_CountLink_ExtensionsAria": "Open extensies (codes) die naar deze telefoonserver worden gefilterd",
    "TelsysList_CountLink_AcdAgentsAria": "Open ACD-agents die naar deze telefonieserver zijn gefilterd.",
    "TelsysList_CountLink_AppUsersAria": "Gebruikers van open applicaties worden doorgestuurd naar deze telefonieserver.",
    "NAME": "TelsysListLanguage"
}